<template>
  <div class="people-recognition">
    <div
      v-if="isEmpty"
      class="empty"
    >
      <img :src="imageError">
      <h6>{{ message }}</h6>
    </div>
    <div
      :class="[
        'character-album',
        { 'character-album-single': peopleList.length === 1 }
      ]"
      v-else
    >
      <el-carousel
        :autoplay="false"
        arrow="always"
      >
        <el-carousel-item
          v-for="(characterItem, characterIndex) in peopleList"
          :key="characterIndex"
        >
          <h5>{{ characterItem.name }}</h5>
          <h6>
            <i class="icon icon-people-position" />{{ characterItem.position }}
          </h6>
          <dl
            v-for="(item, index) in tagObj"
            :key="index"
            :class="{ introduction: index === 'introduction' }"
          >
            <dt v-if="index !== 'introduction'">
              <i :class="['icon', `icon-people-${index}`]" />{{
                tagObj[index]
              }}：
            </dt>
            <dd
              :title="characterItem[index] || ''"
              :class="{
                hightlight: index === 'lokMa' && characterItem['lokMa'] === '是'
              }"
            >
              <template v-if="index === 'introduction'">
                <i class="icon icon-people-introduction" />人物简介：
              </template>
              {{ characterItem[index] || "" }}
            </dd>
          </dl>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeopleRecognition',
  data() {
    return {
      imageError: require('@assets/imgs/jlxk/image-detail-error.png'),
      tagObj: {
        gender: '性别',
        nation: '民族',
        twoIdentity: '两会身份',
        twoLevel: '两会代表级别',
        level: '身份级别',
        professionCategory: '职业分类',
        region: '现所在地域',
        introduction: '人物简介',
        lokMa: '是否落马'
      }
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  computed: {
    character() {
      return this.detail.character
    },
    peopleList() {
      return (this.character.people && this.character.people.length !== 0 && this.character.people.map(item => {
        let city = item.city === '请选择' ? '' : (item.city || '')
        let country = item.county || ''
        return {
          name: item.name,
          position: item.position,
          gender: String(item.gender) === '1' ? '男' : '女',
          nation: String(item.nation) === '0' ? '汉族' : '其他少数民族',
          twoIdentity: item.category,
          twoLevel: item.level,
          level: item.positionLevel,
          professionCategory: item.professionCategory,
          region: `${item.province}${city}${country}`,
          introduction: item.introduction,
          lokMa: String(item.falldown) === '0' ? '否' : '是'
        }
      })) || []
    },
    isEmpty() {
      return this.peopleList.length === 0
    },
    message() {
      return this.detail.character.msg || (this.detail.checkStatus === 0 ? '此图片暂无检测结果' : '')
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: element-icons;
  src: url("~@assets/fonts/element-icons.woff") format("woff"),
    url("~@assets/fonts/element-icons.ttf") format("truetype");
  font-weight: 400;
  font-display: "auto";
  font-style: normal;
}
/deep/ .el-icon-arrow-right:before {
  content: "\e6e0";
  font-size: 30px;
  font-weight: 700;
}
/deep/ .el-icon-arrow-left:before {
  content: "\e6de";
  font-size: 30px;
  font-weight: 700;
}
/deep/ .el-carousel {
  &__container {
    width: 480px;
    margin: 0 auto;
    min-height: 485px;
  }
  &__arrow {
    width: 30px;
    height: 50px;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 7px 1px rgba(5, 29, 64, 0.21);
    border-radius: 0;
    &--left {
      left: -20px;
    }
    &--right {
      right: -20px;
    }
  }
}
.character-album-single {
  /deep/ .el-carousel {
    &__arrow {
      display: none;
    }
  }
}
.people-recognition {
  .character-album {
    color: #454647;
    h5 {
      margin: 28px 0 14px;
      font-size: 24px;
      color: #333;
    }
    h6 {
      display: flex;
      align-items: center;
      padding-bottom: 9px;
      font-size: 14px;
    }
    i {
      flex-shrink: 0;
      margin-right: 10px;
    }
    dl {
      display: flex;
      padding: 18px 0 4px;
      border-bottom: 1px dashed #dbdbdb;
      font-size: 14px;
      dt {
        display: flex;
        align-items: center;
        color: #666;
        flex-shrink: 0;
        min-width: 73px;
        margin-right: 20px;
      }
      dd {
        &.hightlight {
          color: #f00;
        }
      }
      &.introduction {
        dd {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 20px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
